<template>
  <div class="page-content" id="activityPublicity">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/systemSetupList/systemSetup' }">系统配置</el-breadcrumb-item>
      <el-breadcrumb-item>活动公示设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <div style="font-size: 16px;color: #333333;width: 100%;">
        <div class="iconDiv" style="float: left;">
          .
        </div>
        活动店铺公示设置
        <el-button size="small" @click="editShopTable" v-show="!btnShow" type="text"
          style="float: right;">编辑</el-button>
        <div v-show="btnShow" style="float: right;">
          <el-button type="text" @click="updatecampaigntype" size="small">确认</el-button>
          <el-button type="text" @click="cancel" size="small">取消</el-button>
        </div>
      </div>
      <div class="common_bg_white" style="margin-bottom: 20px;overflow: hidden;">
        <div class="radio_container">
          <div>
            <el-radio v-model="campaigntype" label="0" :disabled="!btnShow" size="mini">全部公示</el-radio>
            <span class="info">所有经销商/店铺申报的活动，审批通过后，在活动公示页面展示。</span>
          </div>
          <div>
            <el-radio v-model="campaigntype" label="1" :disabled="!btnShow" size="mini">全部都不公示</el-radio>
            <span class="info">所有经销商/店铺申报的活动，都不在活动公示页面展示。</span>
          </div>
          <div>
            <el-radio v-model="campaigntype" label="2" :disabled="!btnShow" @change="reloadData"
              size="mini">部分店铺不公示</el-radio>
            <span class="info">选择部分店铺，申报通过的活动信息，不在活动公示页面公示。</span>
          </div>
          <div v-if="shopPage.editShop && campaigntype == 2">
            <div class="addFont" @click="setShopShow = true">
              <i class="el-icon-plus"></i>
              设置店铺
            </div>
          </div>
        </div>
      </div>
      <el-dialog title='设置店铺' :visible.sync="setShopShow && shopPage.editShop && campaigntype == 2"
        :close-on-click-modal="false" width="960px" id="activityDeclarationdialog">
        <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入店铺名称" v-model="valueIndex"
          :button-texts="['到左边', '到右边']" :titles="['全部授权店铺', '不公示活动店铺']" :data="transferData" @change="leftChange">
        </el-transfer>
        <span slot="footer">
          <el-button size="small" type="TheCustom" @click="setShopShow = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>

    <div style="font-size: 16px;color: #333333;width: 100%;">
      <div class="iconDiv" style="float: left;">
        .
      </div>
      活动内容公示设置
      <el-button size="small" @click="activeContent(1)" v-show="!contentShow" type="text"
        style="float: right;">设置</el-button>
      <div v-show="contentShow" style="float: right;">
        <el-button type="text" @click="sureContent" size="small">确认</el-button>
        <el-button type="text" @click="activeContent(2)" size="small">取消</el-button>
      </div>
    </div>
    <setTheField ref="childSetTheField"></setTheField>

    <div style="font-size: 16px;color: #333333;width: 100%;margin-bottom: 20px;margin-top: 17px;">
      <el-button size="small" @click="urlContent(1)" v-show="!contentShow2" type="text"
        style="float: right;">设置</el-button>
      <div v-show="contentShow2" style="float: right;">
        <el-button type="text" @click="sureUrlContent" size="small">确认</el-button>
        <el-button type="text" @click="urlContent(2)" size="small">取消</el-button>
      </div>
    </div>
    <setUrlTheField ref="childUrlField" style="margin-top: 65px;"></setUrlTheField>
  </div>
</template>

<script>
import setTheField from "./setTheField";//自定义字段
import setUrlTheField from "./setUrlTheField";//自定义字段
import axios from "axios";
export default {
  name: "activityPublicity",
  components: { setTheField, setUrlTheField },
  data() {
    return {
      transferData: [],
      contentArr: [],
      valueIndex: [],
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      setShopShow: false,
      contentShow: false,
      campaigntype: '',
      btnShow: false,
      //不公示活动店铺
      shopPage: {
        pageNo: 1,
        pageSize: 5000,
        editShop: false,
      },
      contentShow2: false,
    }
  },
  created() {
    this.selectbmcCampaigntype()
  },
  methods: {
    generateData() {
      this.transferData = [];
      this.contentArr.forEach((city, index) => {
        this.transferData.push({
          label: city.shopname,
          key: index,
        });
      });
      return this.transferData;
    },
    leftChange(left, right) {
      let idsArr = []
      if (left instanceof Array) {
        this.valueIndex = left
      } else {
        this.valueIndex = right
      }
      if (this.valueIndex && this.valueIndex.length != 0) {
        for (let b in this.valueIndex) {
          idsArr.push(this.contentArr[this.valueIndex[b]].id)
        }
      }
      // this.updateCampaignstatusall(idsArr.join(','))
      this.updateCampaignstatusall(idsArr)
    },
    // 调用子组件
    urlContent(e) {
      if (e == 1) {
        this.contentShow2 = true
        this.$refs.childUrlField.wlShow(1);
      } else {
        this.contentShow2 = false
        this.$refs.childUrlField.wlShow(2);
      }
    },
    // 调用子组件
    activeContent(e) {
      if (e == 1) {
        this.contentShow = true
        this.$refs.childSetTheField.wlShow(1);
      } else {
        this.contentShow = false
        this.$refs.childSetTheField.wlShow(2);
      }
    },
    // 调用子保存
    sureUrlContent() {
      this.contentShow2 = false
      this.$refs.childUrlField.saveSort()
    },
    // 调用子保存
    sureContent() {
      this.contentShow = false
      this.$refs.childSetTheField.saveSort()
    },
    reloadData() {
      let data = {
        pageNo: 1,
        pageSize: 5000,
      }
      this.getPageByBmcs(data)//公示
    },
    updateCampaignstatusall(data) {
      let params = {
        ids: data
      }
      fetch({ 
        url: "hcm/hcmShop/updateCampaignstatusall", 
        method: "post",
				headers: {
					'Content-Type': 'application/json',
				},
				noFormat: false,
				responseType: "json",
        data: JSON.stringify(params),
      }).then((res) => {
        if (res.status == '10000') {
          this.reloadData()
        }
      })
    },
    editShopTable() {
      this.shopPage.editShop = true
      this.btnShow = true
      this.shopPage.pageNo = 1
      this.shopPage.pageSize = 10
      if (this.campaigntype == 2) this.reloadData()
    },
    cancel() {
      this.btnShow = !this.btnShow
      this.shopPage.editShop = !this.shopPage.editShop
      this.shopPage.pageNo = 1
      this.shopPage.pageSize = 10
      this.campaigntype = this.unChangeCampaigntype
    },
    // 确认选择活动公示设置
    updatecampaigntype() {
      //设置活动公示方式
      if (this.campaigntype == '') {
        this.$message.warning('请选择活动公示方式')
        return false
      }
      fetch({ url: "hcm/cus/updatecampaigntype", method: "post", data: { campaigntype: this.campaigntype } })
        .then((res) => {
          if (res.status == '10000') {
            this.unChangeCampaigntype = this.campaigntype
            this.$message.success('成功')
            if (this.campaigntype == 2) {
              this.cancel()
            } else {
              this.btnShow = !this.btnShow
            }
          }
          else this.$message.error(res.message);
        })
    },
    // 初始化回显设置
    selectbmcCampaigntype() {
      fetch({ url: "/hcm/cus/selectbmcSetting", method: "get" }).then((res) => {
        if (res.status == '10000') {
          this.campaigntype = res.data.campaigntype
          this.unChangeCampaigntype = res.data.campaigntype
        }
      })
    },
    getPageByBmcs(params) {
      params.pageSize = 5000
      fetch({ url: "hcm/hcmShop/getPageByBmc", method: "get", params }).then((res) => {
        this.contentArr = []
        this.valueIndex = []
        if (res.data.content && res.data.content.length != 0) {
          for (let a in res.data.content) {
            this.contentArr.push({
              shopname: res.data.content[a].platformname + ' ' + res.data.content[a].shopname,
              campaignstatus: res.data.content[a].campaignstatus,
              id: res.data.content[a].id
            })
            if (res.data.content[a].campaignstatus == 1) {
              this.valueIndex.push(Number(a))
            }
          }
          this.generateData()
        }
      })
    },
  }
}
</script>

<style lang="scss">
@import "style/fontSize.scss";

#activityPublicity {
  .el-transfer {
    font-size: 14px;
    height: 500px !important;
  }

  .el-transfer-panel {
    width: 324px !important;
    height: 500px !important;
  }

  .el-transfer-panel__list.is-filterable {
    height: 396px !important;
  }

  .addFont {
    color: #108cee;
    font-weight: bold;
    text-align: center;
    border: 1px dashed #e8ebec;
    height: 30px;
    width: 425px;
    line-height: 30px;
    cursor: pointer;
  }

  .addFont:hover {
    border: 1px dashed #108cee;
  }

  .iconDiv {
    width: 5px;
    background-color: #333333;
    margin-right: 10px;
    height: 21px;
    margin-top: 4px;
  }

  .unGs {
    display: flex;
    justify-content: space-between;

    .shopTable:first-child {
      width: 50%;
      margin-right: 40px;
    }

    .shopTable:last-child {
      width: 50%;

      .el-table__empty-text {
        display: none;
      }
    }
  }

  .main_content {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;

    &>div {
      width: 49%;
    }
  }

  // .el-radio__input.is-checked .el-radio__inner{
  //     background: #bda470;
  //     border-color: #bda470;
  // }
  // .el-radio__inner{
  //     width: 21px;
  //     height: 21px;
  // }
  // .el-radio__inner::after{
  //     width: 7px;
  //     height: 7px;
  // }
  .el-radio__input.is-checked+.el-radio__label {
    color: #606266;
  }

  .el-radio {
    width: 230px;
    font-size: 16px;
  }

  .el-radio__label {
    font-size: 16px;
  }

  .radio_container {
    margin-bottom: 20px;
  }

  .radio_container>div {
    margin-bottom: 16px;
  }

  .info {
    font-size: 14px;
    color: #666;
  }

  .white_bg {
    margin-top: 20px;
    background: #fff;
    min-height: 630px;
  }

  .el-table {
    min-height: 550px;
  }

  .unb-seaerch-wrapper {
    .el-table {
      min-height: 530px;
    }
  }
}
</style>
